import { defineComponent } from "vue";
import VueMultiselect, { pointerMixin } from "vue-multiselect";
// vue-multiselect with its list scrolling fixed (CLD-1354). Registered globally as <multiselect> in app.ts;
// import this rather than "vue-multiselect" directly.
//  - On open, the list scrolls to, and points at, the selected option (the first one, for a multiple select),
//    the way a native <select> does. Out of the box it always opens at the top.
//  - Arrow up/down keep the pointed option in view. vue-multiselect scrolls by pointer * optionHeight (40px),
//    but the portal's rows are shorter (and can wrap), so the list over-scrolled and hid the pointer.
// Both measure the rendered rows instead of trusting optionHeight.
export default defineComponent({
    name: "Multiselect",
    extends: VueMultiselect,
    watch: {
        // Merged with vue-multiselect's own isOpen watcher, which still runs first.
        isOpen(open) {
            if (open) {
                this.$nextTick(() => this.revealSelectedOption());
            }
        },
    },
    methods: {
        revealSelectedOption() {
            const self = this;
            const options = self.filteredOptions || [];
            const index = options.findIndex((option) => option && !option.$isLabel && self.isSelected(option));
            if (index < 0)
                return;
            // Keyboard navigation carries on from the selected option, not from the top of the list.
            self.pointer = index;
            self.scrollToRow(index, true);
        },
        pointerForward() {
            this.movePointer(pointerMixin.methods.pointerForward);
        },
        pointerBackward() {
            this.movePointer(pointerMixin.methods.pointerBackward);
        },
        // Runs vue-multiselect's pointer move (which skips group labels), throws away the scroll it applied,
        // and scrolls just enough to keep the pointed row visible.
        movePointer(move) {
            var _a;
            const self = this;
            const list = self.$refs.list;
            const scrollTop = (_a = list === null || list === void 0 ? void 0 : list.scrollTop) !== null && _a !== void 0 ? _a : 0;
            move.call(self);
            if (!list)
                return;
            list.scrollTop = scrollTop;
            self.scrollToRow(self.pointer, false);
        },
        // centre: put the row in the middle of the list; otherwise scroll the least needed to show it whole.
        scrollToRow(index, centre) {
            const list = this.$refs.list;
            if (!list)
                return;
            // Option rows are the only .multiselect__element items, rendered in filteredOptions order.
            const row = list.querySelectorAll(".multiselect__element")[index];
            if (!row)
                return;
            const rowTop = row.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
            const rowBottom = rowTop + row.offsetHeight;
            if (centre) {
                list.scrollTop = Math.max(0, rowTop - (list.clientHeight - row.offsetHeight) / 2);
            }
            else if (rowTop < list.scrollTop) {
                list.scrollTop = rowTop;
            }
            else if (rowBottom > list.scrollTop + list.clientHeight) {
                list.scrollTop = rowBottom - list.clientHeight;
            }
        },
    },
});
